import React, { useEffect } from 'react';
import { useWebModalStore } from '@/hooks/useWebModalStore';
import { isMobile } from '@/biz/tool';
import WebModal from '@/components/web/components/Modal';
import { useOrderListStore } from '@/hooks/useOrderListStore';
import { ReactComponent as FlowerIcon } from '@/assets/icons/flower.svg';
import { useTranslation } from 'react-i18next';

const ModalRefuseCampaign: React.FC<{}> = () => {
  const {
    showModalRefuseCampaign,
    setShowModalRefuseCampaign,
    setShowSelectInvitedOrderModal
  } = useWebModalStore();
  const { reQueryOrderListData } = useOrderListStore();
  const { t } = useTranslation();
  useEffect(() => {
    if (showModalRefuseCampaign) {
      handleShowInvitedList();
    }
  }, [showModalRefuseCampaign]);

  const handleShowInvitedList = async () => {
    // 弹窗 请求invited 订单，并弹窗
    const orderListObject = await reQueryOrderListData();
    const { active = [] } = orderListObject || {};
    if (active.length > 0) {
      setShowSelectInvitedOrderModal(true);
    }
  };

  return (
    <>
      <WebModal
        visible={showModalRefuseCampaign}
        isShowHeader={false}
        isShowFooter={false}
        width={isMobile() ? 342 : 624}
      >
        <div
          className={`w-full flex-col justify-start items-center gap-6 inline-flex`}
        >
          <div className="flex-col justify-start items-center gap-8 inline-flex mb-2">
            <div className="self-stretch flex-col justify-start items-center gap-2 flex">
              {/* icon FlowerIcon */}
              <FlowerIcon />
              <div
                className={`self-stretch text-center text-[#1c2024] font-semibold font-['Geist'] leading-loose ${isMobile() ? 'text[20px]' : 'text-xl'}`}
              >
                {t('modal.refuse_campaign.title', {
                  defaultValue: 'Thanks for your feedback!'
                })}
              </div>
              <div
                className={`self-stretch text-[#60646c] text-center font-normal font-['Inter'] leading-normal ${isMobile() ? 'text[14px]' : 'text-base'}`}
              >
                {t('modal.refuse_campaign.description', {
                  defaultValue:
                    'No worries! We’ve noted your preference. We’ll keep recommending brand opportunities that better match your content and goals, so the next one feels like a great fit.'
                })}
              </div>
            </div>
          </div>
          <div className="w-full flex flex-col items-center gap-2">
            <button
              className={`mui-btn-primary  !h-10
                ${isMobile() ? '!w-[300px]' : '!w-[400px]'}`}
              onClick={() => setShowModalRefuseCampaign(false)}
            >
              {t('modal.refuse_campaign.got_it_btn', {
                defaultValue: 'Got it'
              })}
            </button>
          </div>
        </div>
      </WebModal>
    </>
  );
};

export default ModalRefuseCampaign;
